<template>
  <div
    class="logo"
    :class="{'logo--light': isLight }"
  >
    <template v-if="logoUrl">
      <a
        :href="logoUrl"
        target="_blank"
        rel="noopener"
      >
        <img
          v-if="isLight"
          class="responsive-logo-sidebar no-top-margin"
          :src="lightLogoPath"
        >
        <img
          v-else
          class="responsive-logo"
          :src="darkLogoPath"
        >
      </a>
    </template>
    <template v-else>
      <img
        v-if="isLight"
        class="responsive-logo-sidebar no-top-margin"
        :src="lightLogoPath"
      >
      <img
        v-else
        class="responsive-logo"
        :src="darkLogoPath"
      >
    </template>
  </div>
</template>
<script>
  // Import logos
  const NATA_VISUAL_0 = require('../../assets/NATA_Visual_0.png');
  const NATA_VISUAL_1 = require('../../assets/NATA_Visual_1.png');
  const LOGO_PNG = require('../../assets/logo.png');
  const NATA_BLUE = require('../../assets/nata-blue.png');
  const NATA_WHITE = require('../../assets/nata-white.png');
  const NATA_2026_CONFERENCE = require('../../assets/logos/nata-2026-conference.webp');

  // Logo mapping: base name -> { light: path, dark: path }
  const LOGO_MAP = {
    'NATA_Visual': {
      light: NATA_VISUAL_1,
      dark: NATA_VISUAL_0
    },
    'nata': {
      light: NATA_WHITE,
      dark: NATA_BLUE
    },
    'logo': {
      light: LOGO_PNG,
      dark: LOGO_PNG
    },
    'nata_2026_conference': {
      light: NATA_2026_CONFERENCE,
      dark: NATA_2026_CONFERENCE
    }
  };

  export default {
    props: {
      isLight: {
        type: Boolean,
        default: false
      },
      isLandscape: {
        type: Boolean,
        default: false
      },
      isPortrait: {
        type: Boolean,
        default: false
      },
      logoName: {
        type: String,
        default: null
      },
      logoUrl: {
        type: String,
        default: "https://nata.com.au/"
      }
    },
    computed: {
      lightLogoPath() {
        if (this.logoName && LOGO_MAP[this.logoName]) {
          return LOGO_MAP[this.logoName].light;
        }
        return NATA_VISUAL_1;
      },
      darkLogoPath() {
        if (this.logoName && LOGO_MAP[this.logoName]) {
          return LOGO_MAP[this.logoName].dark;
        }
        return NATA_VISUAL_0;
      }
    }
  };
</script>
<style lang="scss">
	@import "../../styles/shared/shared";
  .responsive-logo {
    width: 100%;
    max-width: 500px;
    height: auto;
  }
  .responsive-logo-sidebar {
    width: 100%;
    height: auto;
    @include maxpoint(tablet) {
      margin-top: 0px;
    }
    @include minpoint(tablet) {
      margin-top: 30px;
      max-width: 240px;
    }
  }
  .no-top-margin {
    margin-top: 0px;
  }
	.logo {
		&__landscape {
			@include minpoint(tablet) {
				display: none;
			}
		}
		&__portrait {
			@include maxpoint(phone) {
				display: none;
			}
		}
		&__fill {
			fill: #00257b;
		}
		&--light &__fill {
			fill: $white;
		}
	}
</style>
